import {
  ConditionOperatorKey,
  ConditionOperatorKeyToText,
} from 'common/src/modules/conditions/conditions.types';

/**
 * Validates that an operator is a valid ConditionOperatorKey.
 * @param operator - The operator to validate
 * @returns The validated operator or an error string
 */
export default function setRuleOperator(
  operator: ConditionOperatorKey,
): ConditionOperatorKey | string {
  const validOperators = Object.values(ConditionOperatorKey).filter(
    (v) => typeof v === 'number',
  ) as ConditionOperatorKey[];

  if (!validOperators.includes(operator)) {
    return `Invalid operator "${operator}". Valid operators are: ${validOperators.map((op) => ConditionOperatorKeyToText[op]).join(', ')}`;
  }

  return operator;
}
